export var InternalMessageListeners;
(function (InternalMessageListeners) {
    InternalMessageListeners["closeWalletPopUp"] = "closeWalletPopUp";
    InternalMessageListeners["reloadApp"] = "reloadApp";
    // this can fire on different states
    // it fires when the back button is triggered
    // and the page displayed should not be in the pop up
    // also in general if they close the modal
    InternalMessageListeners["generalModalClose"] = "generalModalClose";
    InternalMessageListeners["rejectedApproval"] = "rejectedApproval";
    InternalMessageListeners["approvedApproval"] = "approvedApproval";
    InternalMessageListeners["showApproval"] = "showApproval";
    InternalMessageListeners["playerProtectionModalOpen"] = "playerProtectionModalOpen";
    InternalMessageListeners["saveSessionStorage"] = "saveSessionStorage";
    InternalMessageListeners["restoreSession"] = "restoreSession";
    InternalMessageListeners["deleteSessionStorage"] = "deleteSessionStorage";
    InternalMessageListeners["routerChanged"] = "routerChanged";
    InternalMessageListeners["sideBarNavItemsReady"] = "sideBarNavItemsReady";
    InternalMessageListeners["changeNetworkProviderEvent"] = "changeNetworkProviderEvent";
    InternalMessageListeners["changeAccountProviderEvent"] = "changeAccountProviderEvent";
    InternalMessageListeners["canAuthenticationBeIntegrated"] = "canAuthenticationBeIntegrated";
    InternalMessageListeners["internalAuthenticationCompleted"] = "internalAuthenticationCompleted";
})(InternalMessageListeners || (InternalMessageListeners = {}));
//# sourceMappingURL=internal-message-listeners.js.map